import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

import { ICON_POSITION } from '../../../../constants';

export type LocationButtonStylesParams = {
  locationButtonDefaultFont: StyleParamType.Font;
  locationButtonDefaultColor: StyleParamType.Color;
  locationButtonHoverFont: StyleParamType.Font;
  locationButtonHoverColor: StyleParamType.Color;
  locationButtonShowIcon: StyleParamType.Boolean;
  locationButtonIconSize: StyleParamType.Number;
  locationButtonIconPosition: StyleParamType.Number;
  locationButtonIconSpacing: StyleParamType.Number;
  locationButtonIconColor: StyleParamType.Color;
};

export const locationButtonStylesParams =
  createStylesParams<LocationButtonStylesParams>({
    locationButtonDefaultFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    locationButtonDefaultColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 1),
    },
    locationButtonHoverFont: {
      type: StyleParamType.Font,
      getDefaultValue: (params) =>
        wixFontParam('Body-M', {
          htmlTag: 'p',
          size: params.isMobile ? 14 : 16,
        })(params),
    },
    locationButtonHoverColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 0.7),
    },
    locationButtonShowIcon: {
      type: StyleParamType.Boolean,
      getDefaultValue: () => true,
    },
    locationButtonIconSize: {
      type: StyleParamType.Number,
      getDefaultValue: () => 24,
    },
    locationButtonIconPosition: {
      type: StyleParamType.Number,
      getDefaultValue: () => ICON_POSITION.LEFT,
    },
    locationButtonIconSpacing: {
      type: StyleParamType.Number,
      getDefaultValue: () => 8,
    },
    locationButtonIconColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-action', 1),
    },
  });
